import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
  Freetext,
} from "../common/commonDomain";
import { FreetextForm } from "./freetextDomain";
import { Decision } from "../project/projectDomain";
import { DecisionType } from "../../common/decisions";

export const freetextHandler: DecisionTypeHandler<DecisionType.freetext, Freetext, FreetextForm> = {
  type: DecisionType.freetext,

  initNewForm: (
    dispatch: DbotEventDispatcher,
    context: DecisionContext,
    data?: Freetext,
    decision?: Decision,
  ): FreetextForm => {
    return new FreetextForm(dispatch, context, data, decision);
  },

  isValid: (form: FreetextForm): boolean => {
    return form.localizedTitles.isValid;
  },

  validate: (form: FreetextForm): boolean => form.localizedTitles.validate(),

  applyForm: (form: FreetextForm): Freetext => {
    return {
      type: DecisionType.freetext,
      localizedTitles: form.localizedTitles.localizedTexts,
      freetextTypeForAllDocuments: form.selectedFreetextType,
      customizedFreetextTypePerDocument: form.toCustomizedFreetextTypePerDocument(),
      requiresGeneralMeeting: form.requiresGeneralMeeting.value ?? false,
    };
  },

  handleEvent(form: FreetextForm, event: DbotEvent) {
    form.handleEvent(event);
  },
};
